import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IReceptionListingViewModel } from '../../../../models/reception';
import { DateTimeHelper } from '../../../../utils/DateTimeHelper.util';

@Component
class MHReceptionSidebar extends Vue {
  /**
   *
   */
  constructor() {
    super();

  }
  @Prop({ default: {}, type: [Object] })
  reception: IReceptionListingViewModel;

  get lblSetting() {
    return {
      ...require('@/locales/generic-labels').default,
      ...require('@/locales/reception').default,
      ...require('@/locales/ticket').default
    }
  }
  get coChannelLink(): string {
    return this.$route.path === '/vehicle-check' ? `/vehicle-check/${this.reception.id}` : `/reception/${this.reception.id}`;
  }
  get coBlockName(): string { return this.reception.block.name }
  get coAddress(): string {
    return `${this.reception.block.address.line1} ${this.reception.block.address.zip_code} ${this.reception.block.address.city} `
  }
  get coLastAction(): string {
    return DateTimeHelper.parseDateTime(this.reception.updatedAt)
  }
  get coNumberOfKeyItem(): string {
    return this.reception.nb_ko_item;
  }
  get coCreatedAt(): string {
    return DateTimeHelper.parseDate(this.reception.createdAt)
  }
  get coCreatedBy(): string {
    return [this.reception.createdBy.firstname || '', this.reception.createdBy.lastname || ''].join(' ')
  }
  get coReceptionName(): string {
    return this.reception.name;
  }

}

export default MHReceptionSidebar;



// WEBPACK FOOTER //
// ./src/containers/mh-reception/components/mh-reception-list-item/index.ts